import React, { forwardRef, useImperativeHandle, useLayoutEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import TimesheetRowWithControl from './TimesheetRowWithControl';
import TimesheetTableHeaders from './TimesheetTableHeaders';
import { displayValueForTimeEntry, getColumnSum, formatDays, formatDateAndMonth } from '../../common/timesheetFunction';
import { updateTimesheetScrollButton } from './timesheetSlice';
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumberWithTwoDigitInteger, getValueFromResource } from '../../common/timeLiveFunction';
import { t } from 'i18next';

const TimesheetTableSectionTwo = forwardRef((props, ref) => {
// const TimesheetTableSectionTwo = () => {
  const { timeEntriesList, isLoading, decimalFormat, isTimesheetPolicy, IsMyTimeOff } = useAppSelector((state => state.timesheet));
  const { showTimeOffInTimesheet,cultureInfoName,decimalPlaces } = useAppSelector((state) => state.globalState);
  const dispatch = useAppDispatch();
  const scrollRef = useRef<HTMLDivElement>(null);
  let timeEntryHeader = [];
  let isHoliday = false;
  if (timeEntriesList[0]) {
    for (var i = 0; i < timeEntriesList[0].timeEntries.length; i++) {
      timeEntryHeader.push({
        "TimeEntryDate": timeEntriesList[0].timeEntries[i].TimeEntryDate,
        "Holiday": timeEntriesList[0].timeEntries[i].Holiday == null ? 0 : timeEntriesList[0].timeEntries[i].Holiday,
        "IsDayOff": timeEntriesList[0].timeEntries[i].isDayOff == null ? 0 : timeEntriesList[0].timeEntries[i].isDayOff,
        "HolidayName": timeEntriesList[0].timeEntries[i].holidayName == null ? '' : timeEntriesList[0].timeEntries[i].holidayName
      });
    }
  }
  useImperativeHandle(ref, () => ({
    scrollLeft: () => {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft -= 150;
      }
    },
    scrollRight: () => {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft += 150;
      }
    }
  }));

  useLayoutEffect(() => {
    const tableScroll = scrollRef.current;
    if (tableScroll && tableScroll.scrollWidth > tableScroll.clientWidth) {
      dispatch(updateTimesheetScrollButton(true))
    } else {
      dispatch(updateTimesheetScrollButton(false))
    }
  }, [timeEntriesList]);


const removeYear = (date: string) => {
    return date
        // year at start e.g. 2025/29/12 → 29/12
        .replace(/^\d{4}[\/\-\.]/, '')
        // year at end e.g. 29/12/2025 → 29/12
        .replace(/[\/\-\.]\d{4}$/, '')
        .trim();
};

  return (
    <div id="section-two" ref={scrollRef} className={"datePanel tableContainerCol"}>
      <table id="tblHoursInput" className={"table data-table time-entry-table"}>
        <thead>
          <tr>
            <TimesheetTableHeaders />
          </tr>
        </thead>
        <tbody>
          {!isLoading && timeEntriesList.map((x) =>
            x.isTimeOff != true &&
            <TimesheetRowWithControl
              key={x.rowId}
              rowId={x.rowId}
            />
          )}
       {IsMyTimeOff && showTimeOffInTimesheet && (
    <tr style={{ height: '15px' }}>
      {timeEntryHeader.map((_, i) => (
        <td key={`blank-${i}`} style={{ borderLeftStyle: 'hidden', borderRightStyle: 'hidden', borderBottom: '1px solid #eff2f5', padding: 0 }}></td>
      ))}
    </tr>
  )}
          {IsMyTimeOff && showTimeOffInTimesheet && <tr className={"timesheet-row"}>
            {timeEntryHeader.map((x: any, i: any) =>
              <td key={i} style={{ height: 74, borderLeftStyle: 'hidden' }}>
                <div style={{ height: 58, fontSize: 13, padding: 10, textTransform: 'uppercase', backgroundColor: x.IsDayOff == 1 ? '#172b4d1a' : '#f0f1f4', borderTopLeftRadius: i == 0 ? '5px' : '0px', borderBottomLeftRadius: i == 0 ? '5px' : '0px' }}>
                  <div style={{ marginBottom: -6 }}>
                    <span>{formatDays(x.TimeEntryDate)}</span>
                  </div>
                   <span className="tsHeaderDateLabel">
                                 {removeYear(
                                   formatDateWithDateAndMonthName(x.TimeEntryDate, cultureInfoName.toString())
                                 )}
                                
                               </span>
                </div>
              </td>
            )}
          </tr>}
          {IsMyTimeOff && showTimeOffInTimesheet && !isLoading && timeEntriesList.map((x) =>
            x.isTimeOff &&
            <TimesheetRowWithControl
              key={x.rowId}
              rowId={x.rowId}
              isReadOnly={true}
            />
          )}
          {IsMyTimeOff && showTimeOffInTimesheet && !timeEntriesList.some((x: any) => x.isTimeOff) && (
  <tr style={{ height: '45px' }}>
    <td 
      colSpan={timeEntryHeader.length} 
      style={{ 
        borderLeftStyle: 'hidden', 
        borderRightStyle: 'hidden', 
        padding: 0, 
        backgroundColor: '#ffffff',
        verticalAlign: 'middle',
        textAlign: 'center' 
      }}
    >
      <span style={{ color: '#a1a5b7', fontSize: '15px', fontWeight: '500'}}>
        {getValueFromResource('No Record Found', dispatch, t)}
      </span>
    </td>
  </tr>
)}
        </tbody>
        <tfoot>
          <tr className={"timesheet-row total-row dark"}>
            {getColumnSum(timeEntriesList, showTimeOffInTimesheet)?.map((x, i) =>
              <td key={i} style={{ padding: 0 }}>
                <div className='tsTableHeaderBackground' style={{ height: 55, marginTop: 8, verticalAlign: 'middle', borderTopLeftRadius: i == 0 ? '5px' : '0px', borderBottomLeftRadius: i == 0 ? '5px' : '0px' }}>
                  <span className={"footer-duration-value"}>{decimalFormat ?  FormatInvoiceDecimalNumberWithTwoDigitInteger(cultureInfoName.toString(), x, 2) : displayValueForTimeEntry(x, isTimesheetPolicy, decimalFormat)}</span>
                </div>
              </td>)
            }
          </tr>
        </tfoot>
      </table>
    </div>
  )
})

export default TimesheetTableSectionTwo